import { useNotification } from '../../contexts/NotificationContext';
import { TransitionGroup } from 'react-transition-group';
import { Grow } from '@material-ui/core';
import { ToastNotification } from './ToastNotification';
import clsx from 'clsx';

export const Toaster = () => {
  const notification = useNotification();
  const classes = useStyles();

  const handleDismiss = (toast: ToastNotification) => {
    if (toast.dismissible) notification.dismissNotification(toast.id);
  };

  return (
    <div className={clsx(classes.container)}>
      <TransitionGroup>
        {notification.notifications.map((toast, index: number) => (
          <Grow key={index}>
            <ToastNotification
              notification={toast}
              onDismiss={() => handleDismiss(toast)}
            />
          </Grow>
        ))}
      </TransitionGroup>
    </div>
  );
};

const useStyles = () => ({
  container: 'fixed right-2 z-[9999] w-full sm:max-w-sm',
});
